import React, { useEffect, useState, useContext } from "react";

import DataTable from "examples/Tables/DataTable";
import Pagination from "@mui/material/Pagination";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import CircularProgress from "@mui/material/CircularProgress";
import { LanguageContext } from "App";
import MDButton from "components/MDButton";
import { Card } from "@mui/material";
const EntriesTable = ({ Entries, GetEntries, SearchRequest, setSearchRequest }) => {
  const { translations } = useContext(LanguageContext);

  const TableColumns = [
    { Header: translations.createAccountsessionPackageSearchId, accessor: "Id", align: "left" },
    { Header: translations.SearchEnteryEntryType, accessor: "EntryType", align: "left" },
    { Header: translations.CreateAccountingEntrypgtitle, accessor: "Title", align: "left" },
    {
      Header: translations.SearchEnteryTablePaymentMethod,
      accessor: "PaymentMethod",
      align: "left",
    },
    { Header: translations.SearchEnterydescription, accessor: "Description", align: "left" },
    { Header: translations.CreateAccountingEntrypgAmount, accessor: "Amount", align: "center" },
    { Header: translations.SearchEnterycategory, accessor: "Category", align: "center" },
    { Header: translations.SearchEnterytableTimeStamp, accessor: "TimeStamp", align: "center" },
    { Header: translations.SearchEnterytableIsProfit, accessor: "IsProfit", align: "left" },
    { Header: translations.SearchEnterytableCreatedBy, accessor: "CreatedBy", align: "left" },
    {
      Header: translations.SearchEnterytableRelativeData,
      accessor: "RelativeData",
      align: "center",
    },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);

  const [IsLoaded, setIsLoaded] = useState(false);

  const GetRelativeData = (Entry) => {
    let RelativeData = [];
    if (Entry.entryType == "UserBalance") {
      RelativeData.push(
        {
          label: "User: ",
          value: Entry.getUser && Entry.getUser.name,
        },
        {
          label: "Balance: ",
          value: Entry.getUserBalanceEntry && Entry.getUserBalanceEntry.currentBalance,
        },
        {
          label: "Balance Variation: ",
          value: Entry.getUserBalanceEntry && Entry.getUserBalanceEntry.balanceVariation,
        }
      );
    }
    if (Entry.entryType == "AccountingSession") {
      RelativeData.push(
        {
          label: "Session: ",
          value: Entry.getAccountingSession
            ? Entry.getAccountingSession.getSession && Entry.getAccountingSession.getSession.name
            : "Has been refunded with another entry",
        },
        {
          label: "AccSessionId: ",
          value: Entry.getSession && Entry.getAccountingSession.id,
        },
        {
          label: "Patient: ",
          value: Entry.getUser && Entry.getUser.name,
        }
      );
    }
    if (Entry.entryType == "Package") {
      RelativeData.push(
        {
          label: "Package: ",
          value: Entry.getPackage && Entry.getPackage.packageName,
        },
        {
          label: "PackageId: ",
          value: Entry.getPackage && Entry.getPackage.id,
        },
        {
          label: "Patient: ",
          value: Entry.getUser && Entry.getUser.name,
        }
      );
    }
    if (Entry.entryType == "AccountingTherapistHour") {
      RelativeData.push(
        {
          label: "Therapist: ",
          value: Entry.getUser && Entry.getUser.name,
        },
        {
          label: "Therapist User Id: ",
          value: Entry.getUser && Entry.getUser.id,
        },
        {
          label: "Therapist Hour Id: ",
          value: Entry.getAccountingTherapistHour && Entry.getAccountingTherapistHour.id,
        }
      );
    }
    return RelativeData;
  };

  const GetProfitCell = (Entry) => {
    if (Entry.isProfit) {
      return (
        <MDTypography variant="h6" color="success">
          PROFIT
        </MDTypography>
      );
    } else {
      return (
        <MDTypography variant="h6" color="error">
          COST
        </MDTypography>
      );
    }
  };
  const MakeTableRow = (Entry) => {
    console.log(Entry);
    if (!Entry) {
      return null;
    }
    return {
      Id: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.id}
        </MDTypography>
      ),
      EntryType: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.entryType}
        </MDTypography>
      ),

      Title: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.title}
        </MDTypography>
      ),
      PaymentMethod: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry?.paymentMethod ? Entry.paymentMethod : "N/A"}
        </MDTypography>
      ),
      Description: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.description}
        </MDTypography>
      ),
      Amount: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.amount}
        </MDTypography>
      ),

      Category: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.Category}
        </MDTypography>
      ),
      TimeStamp: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.timeStamp}
        </MDTypography>
      ),

      IsProfit: GetProfitCell(Entry),

      CreatedBy: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.getCreator.name}
        </MDTypography>
      ),
      RelativeData: (
        <>
          {GetRelativeData(Entry).map((relativeData, index) => {
            return (
              <MDBox key={index}>
                <MDTypography component="p" variant="button" color="text" fontWeight="medium">
                  {relativeData.label}
                </MDTypography>
                <MDTypography component="p" variant="button" color="text" fontWeight="medium">
                  {relativeData.value}
                </MDTypography>
              </MDBox>
            );
          })}
        </>
      ),
    };
  };

  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);

  useEffect(() => {
    const fetchEntries = async () => {
      SearchRequest.pagingParams.PageNumber = Page;
      setSearchRequest(SearchRequest);
      await GetEntries(SearchRequest);
    };

    fetchEntries();
  }, [Page]);

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((Entry) => {
      rows.push(MakeTableRow(Entry));
    });
    setTableDataRows(rows);
  };

  useEffect(() => {
    if (Entries && Object.keys(Entries).length > 0) {
      setPaginationPages(Entries.totalPages);

      RefreshTable(Entries.list);
    }
  }, [Entries]);

  return (
    <Card className="mt-5">
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        sx={{ backgroundColor: "#3560AD" }}
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
        textAlign="center"
      >
        <MDTypography variant="h6" color="white">
          {translations.SearchEnteryAccountingEntriesTable}
        </MDTypography>
      </MDBox>
      <MDBox pt={3}>
        <DataTable
          table={{ columns: TableColumns, rows: TableDataRows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>

      <div className="text-right mx-3 my-4">
        <Pagination
          count={PaginationPages}
          color="primary"
          onChange={(e, number) => setPage(number)}
          className="float-right"
        />
      </div>
    </Card>
  );
};

export default EntriesTable;
